
/**
 * focus-trap.js
 * A simple library to manage focus-trapping on certain elements.
 * Used for a11y compliance for modals, overlays, menus etc
 */

export function tms_init_focus_trap(element: any) {
  
  // if (!$) {
  //   $ = jQuery;
  // }
  

  const tabbables = element.find('select:visible, input:visible, textarea:visible, button:visible, a:visible');

  const first = tabbables.first();
  const last = tabbables.last();

  first.trigger('focus');

  /* Redirect last tab to first input */
  last.on('keydown', function (e: any) {
    if ((e.code === "Tab" && !e.shiftKey)) {
      e.preventDefault();
      first.trigger('focus');
  }
  });

  /* Redirect first shift+tab to last input */
  first.on('keydown', function (e: any) {
  if ((e.code === "Tab" && e.shiftKey)) {
    e.preventDefault();
    last.trigger('focus');
  }
  });

  return [first, last];

}

export function tms_destroy_focus_trap(bindings: any){
  if (bindings && bindings.length > 0) {
    bindings.forEach( (b: any) => { b.off('keydown'); });
  }
}